import { useMedia } from "use-media";
import { mobileBreakpoint } from "../modules/theme";

export const useIsMobile = () => useMedia({ maxWidth: mobileBreakpoint });



// WEBPACK FOOTER //
// ./src/hooks/mobile.js